import { useMemo } from "react"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import { useMedicalRecordSharedWithMeChangedSubscription as useMedicalRecordSharedWithMeChangedSubscriptionType } from "@/modules/patients/services/__generated__/useMedicalRecordSharedWithMeChangedSubscription.graphql"
import { useSharedMedicalRecordEventsStore } from "@/modules/patients/stores/useSharedMedicalRecordEventsStore"

const subscription = graphql`
  subscription useMedicalRecordSharedWithMeChangedSubscription {
    medicalRecordSharedWithMeChanged {
      requestorUserName
      userNameToShared
      waitingRoomAppointmentId
      temporaryNote
      patient {
        id
        firstName
        lastName
        country
      }
    }
  }
`

const useMedicalRecordSharedWithMeChangedSubscription = () => {
  const subscriptionConfig: GraphQLSubscriptionConfig<useMedicalRecordSharedWithMeChangedSubscriptionType> = useMemo(
    () => ({
      variables: {},
      subscription,
      onNext: (subscriptionResult) => {
        if (subscriptionResult) {
          useSharedMedicalRecordEventsStore
            .getState()
            .registerSharedMedicalRecordEvent(subscriptionResult.medicalRecordSharedWithMeChanged)
        }
      },
      cacheConfig: { metadata: { sensitive: true } },
    }),
    [],
  )

  return useSubscription<useMedicalRecordSharedWithMeChangedSubscriptionType>(subscriptionConfig)
}

export { useMedicalRecordSharedWithMeChangedSubscription }
